import { AlertTriangle, CheckCircle, Clock, Eye, LayoutGrid, Wrench } from 'lucide-react';

export type StoreCategory =
  | 'RUPTURA_CRITICA'
  | 'SCORE_BAIXO'
  | 'SEM_VISITA_LONGA'
  | 'AUDITORIA_PROGRAMADA'
  | 'PLANOGRAMA_PENDENTE'
  | 'MANUTENCAO';

interface CategoryConfig {
  color: string;
  bg: string;
  label: string;
  icon: typeof AlertTriangle;
}

const CATEGORY_CONFIG: Record<StoreCategory, CategoryConfig> = {
  RUPTURA_CRITICA: {
    color: '#dc2626',
    bg: 'bg-red-50',
    label: 'Ruptura',
    icon: AlertTriangle,
  },
  SCORE_BAIXO: {
    color: '#d97706',
    bg: 'bg-orange-50',
    label: 'Score Baixo',
    icon: AlertTriangle,
  },
  SEM_VISITA_LONGA: {
    color: '#d97706',
    bg: 'bg-orange-50',
    label: 'Sem Visita',
    icon: Clock,
  },
  AUDITORIA_PROGRAMADA: {
    color: '#f59e0b',
    bg: 'bg-amber-50',
    label: 'Auditoria',
    icon: Eye,
  },
  PLANOGRAMA_PENDENTE: {
    color: '#f59e0b',
    bg: 'bg-amber-50',
    label: 'Planograma',
    icon: LayoutGrid,
  },
  MANUTENCAO: {
    color: '#16a34a',
    bg: 'bg-green-50',
    label: 'Manutencao',
    icon: CheckCircle,
  },
};

/** Returns the hex color for a given category (used for map markers). Falls back to green. */
export function getCategoryColor(category?: StoreCategory | string | null): string {
  if (!category) return '#16a34a';
  const config = CATEGORY_CONFIG[category as StoreCategory];
  return config?.color ?? '#16a34a';
}

interface StoreScoreBadgeProps {
  category?: StoreCategory | string | null;
  compact?: boolean;
}

export default function StoreScoreBadge({ category, compact }: StoreScoreBadgeProps) {
  if (!category) return null;

  const config = CATEGORY_CONFIG[category as StoreCategory];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.bg} ${compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs'}`}
      style={{ color: config.color }}
    >
      <Icon className={compact ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      {config.label}
    </span>
  );
}
